<template>
  <div>
    <div
        class="modal show fade modal text-left "
        style="display: block;"
        v-if="show"
    >
      <div class="modal-dialog modal-lg" :class="{ 'modal-dialog-centered': centered }">
        <div class="modal-content">
          <div class="modal-header">
            <h4 class="modal-title" style="text-transform:capitalize;">
              Details
            </h4>
            <button
                type="button"
                class="close"
                data-dismiss="modal"
                aria-label="Close"
                @click="$emit('hide')"
            >
              <span aria-hidden="true">&times;</span>
            </button>
          </div>
          <div class="modal-body">
            <div class="card">
              <div class="card-body" v-if="typeof list != 'undefined' &&  Object.keys(list).length != 0">
                <div class="row invoice-spacing">
                  <div class="col-xl-12 p-0">
                    <vue-json-pretty :path="'res'" v-model="list"    :editable="editable"  :showDoubleQuotes="false"> </vue-json-pretty>
                  </div>
                </div>
              </div>
              <div class="card-body text-center text-primary" v-else>
                No Details Avaliable
              </div>
            </div>
          </div>
          <div class="modal-footer justify-content-end">
            <button
                type="button"
                class="btn btn-outline-secondary"
                data-dismiss="modal"
                @click="$emit('hide')"
            >
              Close
            </button>
            <button
                type="button"
                class="btn btn-primary"
                data-dismiss="modal"
                v-if="editable"
                @click="updateRecord"
            >
              Update
            </button>
          </div>
        </div>
      </div>
    </div>
    <div v-if="show" class="modal-backdrop fade show"></div>
  </div>
</template>

<script>
import VueJsonPretty from 'vue-json-pretty';
import 'vue-json-pretty/lib/styles.css';
export default {
  components: {
    VueJsonPretty,
  },
  // props: ["show", "treeData"],
  props: {
    show: Boolean,
    treeData: Object,
    editable: {
      type: Boolean,
      default: false, // Default value for editable is false
    },
    centered: {
      type: Boolean,
      default: false, // opt-in: adds modal-dialog-centered, existing usages unaffected
    },
  },
  data() {
    return {
      list: {},
    };
  },
  methods:{
    updateRecord(){
      this.$emit('updateTreeRecord', this.list)
    }
  },
  watch: {
    show(val) {
      if(val){
        this.list = JSON.parse(JSON.stringify(this.treeData));
      }else{
        this.list = {}
      }
    },
    list(val) {
      this.$emit("updatedTreeVal", val);
    }
  }
};
</script>

<style scoped>
.modal-dialog {
  overflow-y: initial !important
}

.modal-body {
  max-height: 70vh;
  overflow-y: auto;
}
</style>

